import {useAppSelector} from '@/hooks';

export function useGetNumberOfActiveItems(): number {
  return useAppSelector((state) => {
    const currentPageId = state.posterEditor.currentPageId;
    if (!currentPageId) {
      return 0;
    }

    if (!state.posterEditor.activeItemIds[currentPageId]) {
      return 0;
    }

    return state.posterEditor.activeItemIds[currentPageId].length;
  });
}
